import React from "react";

const IconInstagram = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={25}
      height={26}
      viewBox="0 0 25 26"
      fill="none"
      {...props}
    >
      <mask
        id="mask0_292_307"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={25}
        height={25}
      >
        <path
          d="M24.1094 0.782959H0.109375V24.783H24.1094V0.782959Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_292_307)">
        <path
          d="M20.2687 24.2094H3.99922C3.1613 24.2094 2.35771 23.8766 1.7652 23.284C1.17271 22.6915 0.839844 21.8879 0.839844 21.0501V4.78047C0.839844 3.94254 1.17271 3.13895 1.7652 2.54645C2.35771 1.95395 3.1613 1.62109 3.99922 1.62109H20.2687C21.1066 1.62109 21.9102 1.95395 22.5027 2.54645C23.0952 3.13895 23.4281 3.94254 23.4281 4.78047V21.0501C23.4281 21.8879 23.0952 22.6915 22.5027 23.284C21.9102 23.8766 21.1066 24.2094 20.2687 24.2094ZM3.99922 2.88485C3.49646 2.88485 3.0143 3.08456 2.65881 3.44005C2.30331 3.79555 2.1036 4.27771 2.1036 4.78047V21.0501C2.1036 21.5528 2.30331 22.0349 2.65881 22.3904C3.0143 22.7459 3.49646 22.9456 3.99922 22.9456H20.2687C20.7715 22.9456 21.2536 22.7459 21.6092 22.3904C21.9647 22.0349 22.1643 21.5528 22.1643 21.0501V4.78047C22.1643 4.27771 21.9647 3.79555 21.6092 3.44005C21.2536 3.08456 20.7715 2.88485 20.2687 2.88485H3.99922Z"
          fill="#F5FAFA"
        />
        <path
          d="M12.1345 18.7193C10.9863 18.718 9.86416 18.3764 8.91003 17.7374C7.95589 17.0986 7.21258 16.1911 6.77407 15.1299C6.33556 14.0686 6.22155 12.9012 6.44643 11.7751C6.6713 10.6491 7.22498 9.61503 8.03747 8.8036C8.84996 7.99217 9.88478 7.43984 11.0111 7.21644C12.1374 6.99303 13.3047 7.10857 14.3654 7.54846C15.4261 7.98835 16.3326 8.73284 16.9702 9.68782C17.6078 10.6428 17.948 11.7653 17.9478 12.9136C17.9458 14.4541 17.3324 15.9308 16.2425 17.0192C15.1525 18.1078 13.675 18.7193 12.1345 18.7193ZM12.1345 8.36416C11.2365 8.3654 10.359 8.63276 9.61293 9.13246C8.86677 9.63215 8.28544 10.3418 7.94235 11.1716C7.59928 12.0015 7.50984 12.9145 7.68534 13.7952C7.86083 14.6759 8.2934 15.4848 8.9284 16.1198C9.56339 16.7548 10.3723 17.1874 11.253 17.3629C12.1337 17.5383 13.0466 17.449 13.8765 17.1058C14.7065 16.7627 15.416 16.1815 15.9158 15.4352C16.4154 14.6891 16.6828 13.8116 16.6841 12.9136C16.6841 11.707 16.2046 10.5499 15.3515 9.69667C14.4984 8.84348 13.3412 8.36416 12.1345 8.36416Z"
          fill="#F5FAFA"
        />
        <path
          d="M18.7063 7.74073C19.4566 7.74073 20.0648 7.1325 20.0648 6.38221C20.0648 5.63191 19.4566 5.02368 18.7063 5.02368C17.956 5.02368 17.3477 5.63191 17.3477 6.38221C17.3477 7.1325 17.956 7.74073 18.7063 7.74073Z"
          fill="#F5FAFA"
        />
      </g>
    </svg>
  );
};

export default IconInstagram;
